import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  page: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: { xs: 'column', md: 'row' }
  } satisfies SxProps<Theme>,
  brandPanel: {
    flex: '1 1 50%',
    minWidth: 0,
    p: { xs: '32px', md: '45px 70px 64px' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    backgroundImage: 'linear-gradient(337deg, rgba(245, 245, 245, 0) 0%, var(--white) 64%), url(/p2pAuthBackground.jpg)',
    backgroundSize: 'auto, auto 206%',
    backgroundPosition: '0 0, 49% 3%',
    backgroundRepeat: 'no-repeat'
  } satisfies SxProps<Theme>,
  logo: {
    width: '524px',
    maxWidth: 'calc(100% + 34px)',
    ml: { xs: '-24px', md: '-34px' },
    alignSelf: 'flex-start'
  } satisfies SxProps<Theme>,
  brandText: {
    mt: { xs: '24px', md: '35px' },
    maxWidth: '482px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  } satisfies SxProps<Theme>,
  brandHeading: {
    lineHeight: '28px'
  } satisfies SxProps<Theme>,
  brandCopy: {
    fontSize: '18px',
    lineHeight: 1.4
  } satisfies SxProps<Theme>,
  formPanel: {
    flex: '1 1 50%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: { xs: '24px', md: '64px 40px' },
    backgroundColor: 'var(--white)',
    borderLeft: { md: '1px solid var(--border)' }
  } satisfies SxProps<Theme>,
  formCard: {
    width: '100%',
    maxWidth: '640px'
  } satisfies SxProps<Theme>,
  support: {
    display: 'block',
    mt: '24px',
    textAlign: 'center',
    color: 'var(--grey-500)'
  } satisfies SxProps<Theme>
}
